import { AvatarModule } from 'primeng/avatar';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginatorModule } from 'primeng/paginator';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { NgModule } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ColorPickerModule } from 'ngx-color-picker';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { InputSwitchModule } from 'primeng/inputswitch';

const CommonModulesList: any[] = [
  AvatarModule,
  DialogModule,
  NgSelectModule,
  ButtonModule,
  CheckboxModule,
  AutoCompleteModule,
  TooltipModule,
  RadioButtonModule,
  CalendarModule,
  InputMaskModule,
  TableModule,
  PaginatorModule,
  NgxPermissionsModule,
  ToggleButtonModule,
  OverlayPanelModule,
  ConfirmPopupModule,
  ColorPickerModule,
  DividerModule,
  DragDropModule,
  InputSwitchModule,
];

@NgModule({
  declarations: [],
  imports: [...CommonModulesList],
  exports: [...CommonModulesList],
})
export class SettingPrimeNgModule {}
